import { useToInstrumentPrecision } from 'shared-modules/services/hooks';
import { trimFrontZeros } from 'shared-modules/services';

export default function useFormatPrice(instrumentId) {
  const toPrecision = useToInstrumentPrecision(instrumentId);
  return (price) => trimFrontZeros(toPrecision(price));
}
